import { LegacyRestreamDestinations } from "./lib/LegacyRestreamDestinations";
export * from "./lib/RestreamDestinationsTypes";
export * from "./lib/RestreamDestinationsTabSection";
export default LegacyRestreamDestinations;
